import Button from '@rio-cloud/rio-uikit/Button';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

type BottomBarViewRefreshProps = {
    ariaLabel: string;
    isRefreshing: boolean;
    onRefresh: () => void;
    testId?: string;
    trackingKey?: string;
};

export const BottomBarViewRefresh = ({
    ariaLabel,
    isRefreshing,
    onRefresh,
    testId,
    trackingKey,
}: BottomBarViewRefreshProps) => {
    const intl = useIntl();
    const wasRefreshingRef = useRef(isRefreshing);
    const [lastUpdatedAt, setLastUpdatedAt] = useState<Date | null>(() => (isRefreshing ? null : new Date()));

    useEffect(() => {
        if (!lastUpdatedAt && !isRefreshing) {
            setLastUpdatedAt(new Date());
        }

        if (wasRefreshingRef.current && !isRefreshing) {
            setLastUpdatedAt(new Date());
        }

        wasRefreshingRef.current = isRefreshing;
    }, [isRefreshing, lastUpdatedAt]);

    const formattedDateTime = lastUpdatedAt
        ? intl.formatDate(lastUpdatedAt, {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
          })
        : '--';

    return (
        <div>
            <FormattedMessage
                id='intl-msg:ordercom-cloud-frontend.common.last-update.text'
                values={{
                    dateTime: formattedDateTime,
                    refresh: chunks => (
                        <Button
                            bsStyle={Button.PRIMARY}
                            variant={Button.VARIANT_LINK_INLINE}
                            autoTrackingKey={trackingKey}
                            onClick={onRefresh}
                            disabled={isRefreshing}
                            data-testid={testId}
                            aria-label={ariaLabel}
                        >
                            {chunks}
                        </Button>
                    ),
                }}
            />
        </div>
    );
};
